<template>
  <!-- 订单详情卡片 -->
  <div class="cardBox">
    <h4 class="itemName" v-if="data.name">{{ data.name }}</h4>
    <slot name="content">
      <template v-for="(item, index) in data.data" :key="index">
        <van-row class="itemRow" v-if="item.value !== false">
          <van-col :span="data.type == 'longLabel' ? 16 : 8"
            ><span class="">{{ item.label }}</span></van-col
          >
          <van-col :span="data.type == 'longLabel' ? 8 : 16">
            <div class="valueBox">
              <span v-if="data.en === 'productsList'">
                <p>{{ item.value.productPrice }}</p>
                <p>{{ item.value.productAmount }}</p>
              </span>
              <div v-else-if="item.en === 'discount'" class="fvlr couponBox">
                <Coupon v-if="item.couponList && item.couponList.length" :datas="item.couponList" />
                <span class="couponCode" v-if="item.couponCode"> {{ item.couponCode }}</span>
                <span :class="['value', 'discount', item.active ? 'active' : '']">{{ item.value }}</span>
              </div>
              <span v-else @click.stop="clickIcon(item)">
                <span :class="{ value: true, active: item.active, line: item.line, underline: item.underline }">{{ item.value }}</span>
                <span v-if="item.icon" :class="{ phoneBox: item.icon == 'phone' }">
                  <van-icon v-if="item.type == 'icon'" :name="item.icon" size="16" color="#3088c5" />
                  <img v-if="item.src" :src="item.src" class="iconImg" />
                </span>
              </span>
            </div>
          </van-col>
          <div v-if="item.tip">
            {{ item.tip }}
          </div>
          <van-row v-if="item.type === 'imgArr'" style="width:100%">
            <div class="tyreImgBox" style="width:100%">
              <template class="tyreImg" v-for="(src, index) in item.imgArr" :key="index">
                <img v-if="src" class="tyreImg" alt="轮胎照片" :src="src" />
              </template>
            </div>
          </van-row>
        </van-row>
      </template>
    </slot>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import Coupon from '@/components/tyre/Coupon.vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Coupon
  },
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value
    })
    const clickIcon = v => {
      emit('clickIcon', v)
    }
    return {
      ...toRefs(state),
      clickIcon
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  padding-bottom: 16px;
  text-align: left;
  font-size: 14px;
  color: #999;
  :deep(.couponList) {
    width: 180px;
    div {
      margin: 0 3px 3px;
    }
  }
}
.couponBox {
  margin-left: -40px;
}
.itemName {
  font-size: 15px;
  margin-bottom: 12px;
  color: #333;
  font-weight: 600;
  opacity: 0.9;
}
.couponCode {
  margin: 0 10px 0 0;
  overflow-wrap: break-word;
  max-width: 76%;
  text-align: left;
}
.itemRow {
  margin-bottom: 10px;
}
.valueBox,
.value {
  text-align: right;
}
.discount {
  margin-left: 3px;
  min-width: 40px;
}
.active {
  color: #3088c5;
}
.phoneBox {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  transform: rotate(-90deg);
  vertical-align: bottom;
}
.iconImg {
  width: 10px;
  height: 12px;
  margin-left: 6px;
}
.tyreImg {
  width: 78px;
  height: 80px;
  margin: 0 4px 5px 0;
  border: 1px solid #f0f0f0;
  background-repeat: no-repeat;
  background-size: cover;
}
.tyreImgBox {
  display: flex;
  justify-content: flex-start;
  align-items: start;
  flex-wrap: wrap;
  .tyreImg:nth-child(4n) {
    margin-right: 0;
  }
}
</style>
